import { SVGAttributes, VFC } from "react";

const Hamburg: VFC<SVGAttributes<SVGElement>> = ({ ...rest }) => {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M3 12H15M3 6H21M3 18H21"
        stroke="#191817"
        strokeOpacity="0.75"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export { Hamburg };
